import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
        style: {"border-radius":"12px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "Tutorials",
            ripple: ""
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Tutoriels")
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "Modules",
            ripple: ""
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("Modules")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_window, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "Tutorials" }, {
            default: _withCtx(() => [
              _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Suivi d'avancement des tutoriels", -1)),
              _createVNode(_component_v_divider, { class: "my-3" }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  (_ctx.enableWrite)
                    ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.selectedCompanyId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCompanyId) = $event)),
                            items: _ctx.allAvailableCompanies,
                            label: "Sélectionner une entreprise",
                            "item-title": (item) => item.key,
                            "item-value": "value",
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                            clearable: "",
                            density: "compact"
                          }, null, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedUsers,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                        items: _ctx.users,
                        label: "Utilisateurs",
                        "item-title": (item) => item.key,
                        "item-value": "value",
                        multiple: "",
                        dense: "",
                        "small-chips": "",
                        outlined: "",
                        "hide-details": "",
                        clearable: "",
                        density: "compact",
                        style: {"flex-wrap":"wrap","max-width":"100%","overflow-y":"auto","max-height":"100px"},
                        ref: "userSelect"
                      }, {
                        selection: _withCtx(({ item, index }) => [
                          (index < 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: item.value,
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (index === 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 'more-users',
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" + " + _toDisplayString(_ctx.selectedUsers.length - 1) + " autres ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedCategories,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCategories) = $event)),
                        items: _ctx.allCategories,
                        "item-title": (item) => item.text,
                        "item-value": "value",
                        label: "Catégories de tutoriels",
                        multiple: "",
                        "small-chips": "",
                        outlined: "",
                        "hide-details": "",
                        clearable: "",
                        density: "compact",
                        style: {"flex-wrap":"wrap","max-width":"100%","overflow-y":"auto","max-height":"100px"}
                      }, {
                        selection: _withCtx(({ item, index }) => [
                          (index < 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: item.value,
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (index === 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 'more-items',
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" + " + _toDisplayString(_ctx.selectedCategories.length - 1) + " autres ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedStatus,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedStatus) = $event)),
                        items: _ctx.statusOptions,
                        label: "Statut",
                        density: "compact",
                        outlined: "",
                        "hide-details": "",
                        clearable: ""
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        rounded: "xl",
                        elevation: "0",
                        class: "mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                            default: _withCtx(() => [
                              _cache[12] || (_cache[12] = _createTextVNode(" État d'avancement des tutoriels ")),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                class: "elevation-0",
                                rounded: "",
                                dense: "",
                                dark: "",
                                onClick: _ctx.refreshChart
                              }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode(" Actualiser ")
                                ])),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_container, { class: "px-0" }, {
                            default: _withCtx(() => [
                              (_ctx.chartDataReady)
                                ? (_openBlock(), _createBlock(_component_bar_chart, {
                                    key: 0,
                                    data: _ctx.chartData,
                                    options: _ctx.chartOptions,
                                    height: _ctx.$vuetify.display.mobile ? 200 : 300
                                  }, null, 8, ["data", "options", "height"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          (_ctx.selectedUsers.length === 1 && _ctx.filteredTutorials.length)
                            ? (_openBlock(), _createBlock(_component_v_container, {
                                key: 0,
                                class: "px-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_data_table, {
                                    headers: _ctx.tutorialTableHeaders,
                                    items: _ctx.filteredTutorials,
                                    "item-key": "learningObjectId",
                                    class: "elevation-1 table"
                                  }, {
                                    "item.progress": _withCtx(({ item }) => [
                                      (!_ctx.isTutorialCompleted(item))
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            "model-value": _ctx.calculateProgress(item),
                                            color: "primary",
                                            size: "24",
                                            width: "3",
                                            rounded: ""
                                          }, null, 8, ["model-value"]))
                                        : (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 1,
                                            size: "24",
                                            width: "3",
                                            color: "primary"
                                          }, {
                                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                                              _createTextVNode(" $oss-circle-check ")
                                            ])),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "Modules" }, {
            default: _withCtx(() => [
              _cache[18] || (_cache[18] = _createElementVNode("h1", null, "Suivi d'avancement des modules", -1)),
              _createVNode(_component_v_divider, { class: "my-3" }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  (_ctx.enableWrite)
                    ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.selectedCompanyId,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCompanyId) = $event)),
                            items: _ctx.allAvailableCompanies,
                            label: "Sélectionner une entreprise",
                            "item-title": (item) => item.key,
                            "item-value": "value",
                            density: "compact",
                            outlined: "",
                            "hide-details": "",
                            clearable: ""
                          }, null, 8, ["modelValue", "items", "item-title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedUsersForModules,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedUsersForModules) = $event)),
                        items: _ctx.users,
                        label: "Utilisateurs",
                        "item-title": (item) => item.key,
                        "item-value": "value",
                        multiple: "",
                        density: "compact",
                        "small-chips": "",
                        outlined: "",
                        "hide-details": "",
                        clearable: ""
                      }, {
                        selection: _withCtx(({ item, index }) => [
                          (index < 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: item.value,
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (index === 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 'more-users',
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" + " + _toDisplayString(_ctx.selectedUsersForModules.length - 1) + " autres ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedModules,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedModules) = $event)),
                        items: _ctx.allModules,
                        label: "Modules",
                        "item-title": (item) => item.name,
                        "item-value": "id",
                        multiple: "",
                        density: "compact",
                        "small-chips": "",
                        outlined: "",
                        "hide-details": "",
                        clearable: ""
                      }, {
                        selection: _withCtx(({ item, index }) => [
                          (index < 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: item.value,
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (index === 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 'more-items',
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" + " + _toDisplayString(_ctx.selectedModules.length - 1) + " autres ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items", "item-title"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        rounded: "xl",
                        elevation: "0",
                        class: "mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                            default: _withCtx(() => [
                              _cache[16] || (_cache[16] = _createTextVNode(" État d'avancement des modules ")),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                class: "elevation-0",
                                rounded: "",
                                dense: "",
                                dark: "",
                                onClick: _ctx.refreshModuleChart
                              }, {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("Actualiser")
                                ])),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_container, null, {
                            default: _withCtx(() => [
                              (_ctx.moduleChartDataReady)
                                ? (_openBlock(), _createBlock(_component_bar_chart, {
                                    key: 0,
                                    data: _ctx.moduleChartData,
                                    options: _ctx.chartOptions,
                                    height: _ctx.$vuetify.display.mobile ? 200 : 300
                                  }, null, 8, ["data", "options", "height"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          (
                                    _ctx.selectedUsersForModules.length === 1 && _ctx.filteredModules.length
                                )
                            ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_data_table, {
                                    headers: _ctx.moduleTableHeaders,
                                    items: _ctx.filteredModules,
                                    "item-key": "moduleId",
                                    class: "elevation-1 table"
                                  }, {
                                    "item.progress": _withCtx(({ item }) => [
                                      (!_ctx.isModuleCompleted(item))
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            "model-value": _ctx.calculateModuleProgress(item.id),
                                            color: "primary",
                                            size: "24",
                                            width: "3",
                                            rounded: ""
                                          }, null, 8, ["model-value"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.isModuleCompleted(item))
                                        ? (_openBlock(), _createBlock(_component_v_icon, {
                                            key: 1,
                                            size: "24",
                                            width: "3",
                                            color: "primary"
                                          }, {
                                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                                              _createTextVNode(" $oss-circle-check ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["headers", "items"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}